module.exports = __webpack_public_path__ + "media/images/checkbox-checkmark-662339f8.png";